<div class="d-flex align-items-center">
  <div class="fw-bold text-primary font-weight-medium m-0">Items display</div>
  <div *ngIf="loading" class="spinner-grow spinner-grow-sm ms-3" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <select class="form-select m-0 ms-auto" [(ngModel)]="items_display" (ngModelChange)="saveItemsDisplay()" style="width: 130px">
    <option [value]="i" *ngFor="let i of [2,3,4,6]">{{ i }} per row</option>
  </select>
</div>
